import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon, SvgIconType, Portal } from '@integration-app/react';
import clsx from 'clsx';
import { Backdrop } from './Backdrop';
import { PopupContextProvider, useFlowPopupContext } from './popup-context';
import classes from './Popup.module.css';
import { Pane, VBox } from '../../../Layout';
function PopupRoot({ children, open, onClose, className, backdropClassName, backdropType, ...props }) {
    if (!open) {
        return null;
    }
    const handleClick = (event) => {
        var _a, _b, _c;
        (_a = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        (_c = (_b = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _b === void 0 ? void 0 : _b.stopImmediatePropagation) === null || _c === void 0 ? void 0 : _c.call(_b);
    };
    return (_jsx(Backdrop, { onClick: onClose, className: backdropClassName, type: backdropType, children: _jsx(PopupContextProvider, { children: _jsxs("div", { className: clsx(classes.genericPopup, {
                    [classes.blurred]: backdropType === 'blur',
                }, className), onClick: handleClick, ...props, children: [onClose && (_jsx("button", { type: 'button', title: 'Close popup', className: classes.genericPopup_closeButton, onClick: onClose, children: _jsx(SvgIcon, { type: SvgIconType.Close }) })), _jsxs(VBox, { className: classes.genericPopup_contentContainer, children: [_jsx(PopupHeaderPortal, {}), children, _jsx(PopupNotificationPortal, {}), _jsx(PopupFooterPortal, {})] })] }) }) }));
}
function PopupContent({ children, className }) {
    return (_jsx(Pane, { className: clsx(classes.genericPopup_content, className), stretch: true, children: children }));
}
function PopupNotificationPortal() {
    const { setNotificationRef, notificationClassName } = useFlowPopupContext();
    return (_jsx(Pane, { ref: setNotificationRef, className: clsx(classes.genericPopup_notifications, notificationClassName) }));
}
function PopupNotification({ children, className, }) {
    const { notificationRef, setNotificationClassName } = useFlowPopupContext();
    if (!notificationRef) {
        return null;
    }
    setNotificationClassName(className);
    return _jsx(Portal, { node: notificationRef, children: children });
}
function PopupHeaderPortal() {
    const { setHeaderRef, headerClassName } = useFlowPopupContext();
    return (_jsx(Pane, { ref: setHeaderRef, className: clsx(classes.genericPopup_header, headerClassName) }));
}
function PopupHeader({ children, className }) {
    const { headerRef, setHeaderClassName } = useFlowPopupContext();
    if (!headerRef) {
        return null;
    }
    setHeaderClassName(className);
    return _jsx(Portal, { node: headerRef, children: children });
}
function PopupFooterPortal() {
    const { setFooterRef, footerClassName } = useFlowPopupContext();
    return (_jsx(Pane, { ref: setFooterRef, className: clsx(classes.genericPopup_footer, footerClassName) }));
}
function PopupFooter({ children, className }) {
    const { footerRef, setFooterClassName } = useFlowPopupContext();
    if (!footerRef) {
        return null;
    }
    setFooterClassName(className);
    return _jsx(Portal, { node: footerRef, children: children });
}
const GenericPopup = Object.assign(PopupRoot, {
    Content: PopupContent,
    Notification: PopupNotification,
    Footer: PopupFooter,
    Header: PopupHeader,
});
export default GenericPopup;
//# sourceMappingURL=index.js.map